export default "__VITE_ASSET__M1K88ip9__"